// extracted by mini-css-extract-plugin
export default {"container":"AnimatedMeshBackground_container__yp71f"};